import { call, put, takeEvery } from "redux-saga/effects";
import {
    GET_TRANSACTION_PROVISION_SETTLE_LIST,
    GET_TRANSACTION_PROVISION_SETTLE_SEARCH,
    
} from "./actionTypes"

import {
    getTransactionProvisionSettleListSuccess,
    transactionProvisionSettleApiError,
    getTransactionProvisionSettleSearchSuccess,
    
} from "./actions"

import {

    getTransactionProvisionSettleList,
    getTransactionProvisionSettleSearch,
} from "../../helpers/backend_helper/backend_helper"

function* onGetTransactionProvisionSettleList({ payload: record })  {
    try {
        const response = yield call(getTransactionProvisionSettleList,record)
        yield put(getTransactionProvisionSettleListSuccess(response))
    } catch (error) {
        yield put(transactionProvisionSettleApiError(error))
    }
}
function* onGetTransactionProvisionSettleSearch({ payload: record }) {
    try {
        const response = yield call(getTransactionProvisionSettleSearch, record)
        yield put(getTransactionProvisionSettleSearchSuccess(response))
    } catch (error) {
        yield put(transactionProvisionSettleApiError(error))
    }
}


function* transactionProvisionSettleSaga() {
    yield takeEvery(GET_TRANSACTION_PROVISION_SETTLE_LIST, onGetTransactionProvisionSettleList)
    yield takeEvery(GET_TRANSACTION_PROVISION_SETTLE_SEARCH, onGetTransactionProvisionSettleSearch)

}

export default transactionProvisionSettleSaga
